export default {
  scaleScore: 'Scale',
  specialityScore: 'Pro',
  evaluateScore: 'Rating',
  audienceScore: 'Attend',
  marketScore: 'Market',
  exhibitionAddress: 'Address',
  exhibitionHall: 'City',
  exhibitionArea: 'Exhibition area',
  openingHours: 'Show Hours',
  exhibitorsNumber: 'Exhibitors',
  exhibitorsNumberUnit: '',
  audienceSize: 'Visitors',
  audienceSizeUnit: '',
  cycle: 'Annual event',
  boothMap: 'Floorplan',
  getBoothMap: 'Get floorplan',
  subsidy: 'Subsidy',
  yes: 'Yes',
  samePeriodExhibition: 'Same period exhibition',
  viewTime: 'View time',
  viewMap: 'View map',
  exhibitionHallNumber: 'Exhibition hall number',
  travelReminder: 'Travel reminder',
  standardBooth: 'Standard booth',
  bareSpaceBooth: 'Bare space booth',
  projectManagerQuotation: 'Price',
  viewPrice: 'View price',
  lastDay: 'Entry before 14:00 is required on the last day of the exhibition',
  ticketDescription: 'Ticket description',
  exhibitionHighlights: 'Exhibition highlights',
  boothConsult: 'Booth',
  exhibitorPeriodical: 'Exhibitor Directory/E-Magazine',
  distance: 'Days to Open: ',
  day: 'days',
  exhibitionInProgress: 'Exhibition in progress',
  nexttermTimeRenew: 'Nextterm time renew',
  boothApply: 'Booth apply',
  ticketReservation: 'Get Ticket',
  exhibitorDirectory: 'Exhibitor Directory',
  freeForALimitedTime: 'Free for a limited time',
  tourItinerary: 'Tour itinerary',
  weChatShare: 'WeChat share',
  hotelReservation: 'Book hotel',
  exhibitionPicture: 'Photos',
  visaProcessing: 'Visa Processing',
  poster: 'Poster',
  view: '{num} Views',
  exhibitionIntroduction: 'Expo Profile',
  sectionNameExpoProfile: '{name} Expo Profile',
  exhibitsRange: 'Range',
  relatedExhibition: 'Related exhibition',
  industry: 'Industry',
  organizer: 'Organizer',
  exhibitorNumber: 'Exhibitor number',
  exhibitionInvitationLetter: 'Exhibition Invitation letter',
  buyerData: 'Buyer data',
  exhibitionHall2: 'Venue',
  attend: 'People are interested',
  exhibitionReminder: 'Exhibition reminder',
  warmReminder: 'Warm reminder',
  warmReminderContent:
    'There is a certain risk of change in the exhibition time and location. Please refer to the electronic ticket voucher received. The exhibition will also provide phone and SMS notifications for users who book tickets to avoid travel losses',
  notificationReminder: 'Notification reminder',
  addReminder: 'Add reminder',
  viewReminder: 'View reminder',
  openNotification: 'Open notification',
  closeNotification: 'Close notification',
  changeNotice:
    'Check for changes in show hours and transportation information at your fingertips.',
  professionalAudience: 'Visitor Ticket Booking',
  electronic_journal: 'Exhibitor/E-Magazine',
  reserveButton: 'Reserve Now',
  ImmediateGet: 'Get it now',
  relatedHotspotRecommendation: 'Related hotspot recommendation',
  form1: {
    companyName: 'Please enter company name (required)',
    name: 'Please enter the contact name (required)',
    phone: 'Please enter contact number (required)',
    email: 'Please enter your email (optional)',
    remark: 'Please enter Remarks (optional)',
    submit: 'Submit',
    cancel: 'Cancel'
  },

  exhibitorList: 'Exhibitor List '
}
